import React from "react";
import {useNavigate, NavigateFunction} from "react-router-dom";
import {AppState, Auth0Provider} from "@auth0/auth0-react";

type Props = {
    children: React.ReactNode
}

const Auth = ({children}: Props): JSX.Element => {
    const navigate: NavigateFunction  = useNavigate();

    const domain: string = (process.env.REACT_APP_AUTH0_DOMAIN as string);
    const clientId: string = (process.env.REACT_APP_AUTH0_CLIENT_ID as string);
    const audience: string = (process.env.REACT_APP_AUTH0_AUDIENCE as string);

    const onRedirectCallback = (appState?: AppState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            redirectUri={window.location.origin}
            onRedirectCallback={onRedirectCallback}
            audience={audience}
            scope="read:posts read:post create:post update:post delete:post"
        >
            {children}
        </Auth0Provider>
    );
}

export default Auth;